import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useParams, useLoaderData } from 'react-router-dom';
import '../layout/Projectos.Module.css'
import '../layout/DetalheEvento.Module.css'
import { events } from '../events';
import Slider from 'react-slick'
import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from "react-lazy-load-image-component";
import useScrollReveal from './hooks/useScrollReveal';
function DetalheEvento() {
    useScrollReveal(true);
    let {name} = useParams();
    const eve = events.find((e)=>e.title === name);
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const handleImageClick = (index) => {
      setCurrentImageIndex(index);
      setIsFullScreen(true);
    };
    
    const handleClose = () => {
      setIsFullScreen(false);
    };
    
    const handlePrevClick = () => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === 0 ? eve.gallery.length - 1 : prevIndex - 1
      );
    };
    
    const handleNextClick = () => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === eve.gallery.length - 1 ? 0 : prevIndex + 1
      );
    };

    const settings = {
        autoplay: true,
        dots: true,
        infinite: true,
        speed: 1000,
        autoplaySpeed: 6000,
        slidesToShow: 3,
        slidesToScroll: 3,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              initialSlide: 2,
              dots: true
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: false
            }
          }
        ]
      };
  
  const { t, i18n } = useTranslation('');
  return (
    <>
    <div className='Detalhe-evento'>

    <nav aria-label="breadcrumb" className="breadcrumbs medium-font">
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><Link to="/eventos" className="text-decoration-none text-uppercase" role="button" tabIndex="0">{t('navbar.eventos')}</Link></li>
          <li className="breadcrumb-item active text-uppercase" aria-current="page">{eve.title}</li>
        </ol>
    </nav>

    <h1 className='nameP'>{eve?.title}</h1>
    <h2 className='typeP text-uppercase'>{eve?.country[i18n.language]}</h2>
    <h3 className='typeP scroll-bottom'>{eve?.city[i18n.language]}</h3>

    <div className='slide-eventos'>
    {eve?.gallery?.length > 0 && (
  <Slider {...settings}>
    {eve.gallery.map((item, index) => (
      <div className="image-gallery-item" key={index} onClick={() => handleImageClick(index)} style={{ cursor: "pointer" }}>
        <LazyLoadImage  src={item.linkImg} alt={`Imagem ${index + 1}`} />
      </div>
    ))}
  </Slider>
)}
    </div>

   {isFullScreen && (
  <div className='full-screen-carousel'>
    <span className='close' onClick={handleClose}>&times;</span>
    <div className='carousel-content'>
      <button className='carousel-control prev' onClick={handlePrevClick}>
        &#10094;
      </button>
      <img src={eve.gallery[currentImageIndex].linkImg} alt={`Imagem ${currentImageIndex + 1}`} />
      <button className='carousel-control next' onClick={handleNextClick}>
        &#10095;
      </button>
    </div>
  </div>
)}

    <div className='event-info'>
    <hr className="card-line w-100" />
      <div className='grid-info'>
      <div className="image-left">
          {eve?.logo && (
            <img className='logo scroll-bottom' src={eve.logo} alt={eve?.title} />
          )}
          <div>
            <span><strong>{eve?.title1?.[i18n.language]}</strong></span>
              <p className='text-justify' dangerouslySetInnerHTML={{__html: eve?.para1[i18n.language]}}></p>
          </div>
      </div>
        <hr className="card-line w-100" />
        <div className="image-right">
        {eve?.sideRight && (
            <img className='scroll-right' src={eve.sideRight} alt={eve?.title} />
          )}
          {eve?.title2?.[i18n.language] && eve?.para2?.[i18n.language] && (
            <div>
              <span><strong>{eve.title2[i18n.language]}</strong></span>
              <p className='text-justify'>{eve.para2[i18n.language]}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
    </>
  )
}

export default DetalheEvento